import { takeLatest, takeEvery, all } from 'redux-saga/effects'

import { AuthTypes } from 'store/models/auth'
import { logIn, signUp, callConfirmSignup, resendCode } from './authSagas'

import { SupplierTypes } from 'store/models/supplier'
import {
    getSupplier,
    createSupplier,
    updateSupplier,
    reauthenticateSupplier,
    resetProfileForTests,
    getShopifyProducts,
    updateShopifyDetails,
    getShopifyDetails,
    getShopifyProductsCount,
    removeShopifyDetails,
} from './supplierSagas'

import { TransactionsTypes } from 'store/models/transactions'
import { getTransactions, updateTransaction, askForHelp, cancelOrder } from './transactionSagas'

import { TicketsTypes } from 'store/models/tickets'
import { getTickets, closeTicket, getThread } from './ticketSagas'

import { ResourcesTypes } from 'store/models/resources'
import { updateResourceProduct, updateShopifyResource } from './resourceSaga'

import { FinanceTypes } from '../models/finance'
import { getFinance } from './financeSagas'

import { ManagersTypes } from '../models/managers'
import { addManager, getManagers, updateManager, updateManagerRole } from './managerSagas'

import { AnalyticsTypes } from '../models/analytics'
import { postAnalytics } from './analyticsSagas'

import { VouchersTypes } from 'store/models/vouchers'
import { archiveVouchers, deleteVouchers, getVouchers, getVouchersDetails, updateVoucherCode, uploadVouchers } from './vouchersSagas'

export default function* root() {
    yield all([
        takeLatest(AuthTypes.LOG_IN, logIn),
        takeLatest(AuthTypes.SIGN_UP, signUp),
        takeLatest(AuthTypes.CONFIRM_SIGN_UP, callConfirmSignup),
        takeLatest(AuthTypes.RESEND_CODE, resendCode),

        takeLatest(SupplierTypes.GET_SUPPLIER, getSupplier),
        takeLatest(SupplierTypes.UPDATE_SUPPLIER, updateSupplier),
        takeLatest(SupplierTypes.CREATE_SUPPLIER, createSupplier),
        takeLatest(SupplierTypes.REAUTHENTICATE_SUPPLIER, reauthenticateSupplier),
        takeLatest(SupplierTypes.RESET_PROFILE_FOR_TESTS, resetProfileForTests),
        takeLatest(SupplierTypes.GET_SHOPIFY_DETAILS, getShopifyDetails),
        takeLatest(SupplierTypes.GET_SHOPIFY_PRODUCTS, getShopifyProducts),
        takeLatest(SupplierTypes.GET_SHOPIFY_PRODUCTS_COUNT, getShopifyProductsCount),
        takeLatest(SupplierTypes.UPDATE_SHOPIFY_DETAILS, updateShopifyDetails),
        takeLatest(SupplierTypes.REMOVE_SHOPIFY_DETAILS, removeShopifyDetails),

        takeEvery(TransactionsTypes.GET_TRANSACTIONS, getTransactions),
        takeLatest(TransactionsTypes.UPDATE_TRANSACTION, updateTransaction),
        takeLatest(TransactionsTypes.ASK_FOR_HELP, askForHelp),
        takeLatest(TransactionsTypes.CANCEL_ORDER, cancelOrder),

        takeLatest(TicketsTypes.GET_TICKETS, getTickets),
        takeLatest(TicketsTypes.CLOSE_TICKET, closeTicket),
        takeLatest(TicketsTypes.GET_THREAD, getThread),

        takeLatest(ResourcesTypes.UPDATE_RESOURCE_PRODUCT, updateResourceProduct),
        takeLatest(ResourcesTypes.UPDATE_SHOPIFY_RESOURCE, updateShopifyResource),

        takeLatest(FinanceTypes.GET_FINANCE, getFinance),

        takeLatest(ManagersTypes.ADD_MANAGER, addManager),
        takeLatest(ManagersTypes.GET_MANAGERS, getManagers),
        takeLatest(ManagersTypes.UPDATE_MANAGER, updateManager),
        takeLatest(ManagersTypes.UPDATE_MANAGER_ROLE, updateManagerRole),

        // Vouchers
        takeLatest(VouchersTypes.GET_VOUCHERS, getVouchers),
        takeLatest(VouchersTypes.GET_VOUCHERS_DETAILS, getVouchersDetails),
        takeLatest(VouchersTypes.UPLOAD_VOUCHERS, uploadVouchers),
        takeLatest(VouchersTypes.ARCHIVE_VOUCHERS, archiveVouchers),
        takeLatest(VouchersTypes.DELETE_VOUCHERS, deleteVouchers),
        takeLatest(VouchersTypes.UPDATE_VOUCHER_CODE, updateVoucherCode),

        takeEvery(AnalyticsTypes.POST_ANALYTICS, postAnalytics),
    ])
}
